
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 140 140","xmlns":"http://www.w3.org/2000/svg","fill":"currentColor","stroke":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"matrix(5.833333333333333,0,0,5.833333333333333,0,0)"}},[_c('path',{attrs:{"d":"M0.750 12.000 A11.250 11.250 0 1 0 23.250 12.000 A11.250 11.250 0 1 0 0.750 12.000 Z","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M9.750 6.000 A2.250 2.250 0 1 0 14.250 6.000 A2.250 2.250 0 1 0 9.750 6.000 Z","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M13.5,20.25l.75-4.5h1.5V13.5a3.75,3.75,0,0,0-7.5,0v2.25h1.5l.75,4.5Z","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}})])])
          )
        }
      }
    